// Emitted after the settings screens create, rename, switch or delete a funnel, so the CRM
// group of the sidebar, which fetched the funnels once, lists them again.
export const PIPELINES_CHANGED = 'crm:pipelines-changed';
